import * as React from 'react'
import { Testimonial } from '../Testimonial'
import * as API from './lib/api'

interface IProps {
  testimonials: API.ITestimonial[]
  // Caps how many cards render. Omitted by the control checkout (show all);
  // the trial redesign's right rail passes `count={1}` to reuse this markup as
  // a single testimonial card. Values above the list length are harmless.
  count?: number
}

export class Testimonials extends React.Component<IProps, object> {
  public render() {
    const { testimonials, count } = this.props
    const visible = count === undefined ? testimonials : testimonials.slice(0, count)

    return (
      <section className="testimonials list grid-container">
        <div className="grid-x small-up-1 grid-padding-x grid-padding-y">
          {visible.map((testimonial) => {
            return (
              <div key={testimonial.name} className="cell text-left">
                <Testimonial testimonial={testimonial} />
              </div>
            )
          })}
        </div>
      </section>
    )
  }
}
